module.exports = __webpack_public_path__ + "media/theme/SP_HITW_open2-cdd35cba.png";